import { singleton } from "tsyringe";

type ContainerCallback = (width: number) => void;

@singleton()
export class ContainerQueryService {
    private resizeObserver: ResizeObserver;
    private nodeCallbacks = new WeakMap<HTMLElement, Set<ContainerCallback>>();

    constructor() {
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const node = entry.target as HTMLElement;
                const callbacks = this.nodeCallbacks.get(node);
                if (callbacks) {
                    callbacks.forEach((callback) =>
                        callback(entry.contentRect.width)
                    );
                }
            });
        });
    }

    subscribe(node: HTMLElement, callback: ContainerCallback): () => void {
        if (!this.nodeCallbacks.has(node)) {
            this.nodeCallbacks.set(node, new Set());
            this.resizeObserver.observe(node);
        }

        this.nodeCallbacks.get(node)?.add(callback);

        // Initial call
        const rect = node.getBoundingClientRect();
        callback(rect.width);

        // Return unsubscribe function
        return () => {
            const callbacks = this.nodeCallbacks.get(node);

            if (callbacks) {
                callbacks.delete(callback);
                if (callbacks.size === 0) {
                    this.nodeCallbacks.delete(node);
                    this.resizeObserver.unobserve(node);
                }
            }
        };
    }
}
